import Config from 'config';

export const isBreakdownTypeAvailable = reportTitle => ['Payout settlement Report'].includes(reportTitle);

export function buildReportUrl(userId, reportType, fileFormat, timeRange, currency, breakdownType, includeExtendedAuditReport) {
  const commonQueryParams = `&extended=${includeExtendedAuditReport}`;
  const gilaQueryParams = `&gila${commonQueryParams}`;
  const highlanderQueryParams = `&highlander=true${commonQueryParams}`;
  const currencyParams = currency ? `&currency=${currency}` : '';
  const breakdownTypeParams = breakdownType ? `&breakdownType=${breakdownType}` : '';

  // reportType is the report type
  switch (reportType) {
    case 'cost_items':
      // The first iteration of highlander only supports csv
      if (fileFormat.toLowerCase() == 'csv') {
        return `${Config.api.host}/user_reports/${userId}/${reportType}.${fileFormat}${timeRange}${highlanderQueryParams}`;
      }
  }
  return `${Config.api.host}/user_reports/${userId}/${reportType}.${fileFormat}${timeRange}${currencyParams}${breakdownTypeParams}${gilaQueryParams}`;
}



// WEBPACK FOOTER //
// ./src/lib/report-utils.js